import { Link, useParams, useSearchParams } from 'react-router-dom';
import PageHeader from '../components/molecules/PageHeader';
import AddToEventByLevel from '../components/organisms/AddToEventByLevel';
import AddToEventByName from '../components/organisms/AddToEventByName';

const AddToEvent = () => {
  const { eventId, addToEvent } = useParams();
  const [searchParams] = useSearchParams();
  const eventTitle = searchParams.get('event-title');

  let pageOutput = '';

  if (!eventTitle) {
    return <div>Sorry, you have reached an invalid page</div>;
  }

  if (addToEvent === 'add-by-name') {
    pageOutput = <AddToEventByName />;
  } else if (addToEvent === 'add-by-session') {
    pageOutput = <AddToEventByLevel />;
  } else {
    return <div>Sorry, you have reached an invalid page</div>;
  }

  const previousPage = (
    <Link to={`/manage/events/${eventId}`}>Back To Previous Page</Link>
  );
  return (
    <div>
      <PageHeader backLink={previousPage}>
        Add Attendance - {eventTitle}
      </PageHeader>

      <div>{pageOutput}</div>
    </div>
  );
};

export default AddToEvent;
